import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import MyText from "../../components/custom/MyText";
import translate, { descriptionTranslate } from "../../functions/translate";
import { useState } from "react";
import { danger, gray, lightBlue, primary, white } from "../../colors";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import MyButton from "../../components/custom/MyButton";
import ConfirmPhone from "../../components/modals/ConfirmPhoneModal";
import userRegister from "../../api/post/userRegister";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  setConfirmEmailModal,
  setConfirmPhoneModal,
} from "../../redux/modal/modalAction";
import ConfirmEmailModal from "../../components/modals/ConfirmEmailModal";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";

export default function UserRegister() {
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [parent, setParent] = useState("mother");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [nexStep, setNextStep] = useState(false);
  const [nextStepInfo, setNextStepInfo] = useState({});
  const isFocused = useIsFocused();
  const navigation = useNavigation();

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor(lightBlue));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  const [input, setInput] = useState({
    name: null,
    lastName: null,
    nationalCode: null,
    phone: null,
    referId: null,
    province: null,
    city: null,
    email: null,
  });

  const [nextAvailable, setNextAvailable] = useState(
    input.name !== null &&
      input.lastName !== null &&
      (input.phone !== null || input.email !== null) &&
      (!main.rtl || input.nationalCode !== null)
  );

  useEffect(() => {
    setNextAvailable(
      input.name !== null &&
        input.lastName !== null &&
        (input.phone !== null || input.email !== null) &&
        (!main.rtl || input.nationalCode !== null)
    );
  }, [input]);

  const register = () => {
    setError("");
    setLoading(true);

    userRegister(
      input.name,
      input.lastName,
      input.nationalCode,
      input.referId,
      input.province,
      input.city,
      parent,
      input.email,
      input.phone
    )
      .then(({ data }) => {
        const { status, description } = data;
       
        if (status !== 200) {
          if (status === 117) {
     
            setNextStepInfo({
              otp: data.otp,
              temporaryToken: data.temporaryToken,
            });
            main.rtl
              ? dispatch(setConfirmPhoneModal())
              : dispatch(setConfirmEmailModal());
          }
          setError(descriptionTranslate(description));
        } else {
          
          setNextStepInfo({
            otp: data.otp,
            temporaryToken: data.temporaryToken,
          });
          main.rtl
            ? dispatch(setConfirmPhoneModal())
            : dispatch(setConfirmEmailModal());
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  if (main.token !== null) {
    navigation.navigate("Home");
  }
  return (
    <View style={{ flex: 1 }}>
      <ConfirmPhone
        phone={input.phone}
        otp={nextStepInfo.otp}
        temporaryToken={nextStepInfo.temporaryToken}
      />
      <ConfirmEmailModal
        email={input.email}
        otp={nextStepInfo.otp}
        temporaryToken={nextStepInfo.temporaryToken}
      />
      <KeyboardAwareScrollView
        style={{ flex: 1, width: "100%" }}
        contentContainerStyle={{ alignItems: "center" }}
      >
        <MyText style={{ fontSize: 20, marginTop: 20 }}>
          {translate("user details (parent)")}
        </MyText>
        <View
          style={{
            width: "80%",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <TouchableOpacity
            onPress={() => setParent("mother")}
            style={{
              flex: 1,
              padding: 5,
              borderRadius: 7,
              borderWidth: 1,
              borderColor: parent === "mother" ? primary : "#ccc",
              minHeight: 40,
              backgroundColor: parent === "mother" ? primary : "#eee",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MyText style={{ color: parent === "mother" ? white : primary }}>
              {translate("I'm mother")}
            </MyText>
          </TouchableOpacity>
          <View style={{ width: 20 }}></View>
          <TouchableOpacity
            onPress={() => setParent("father")}
            style={{
              flex: 1,
              padding: 5,
              borderRadius: 7,
              borderWidth: 1,
              borderColor: parent === "father" ? primary : "#ccc",
              minHeight: 40,
              backgroundColor: parent === "father" ? primary : "#eee",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MyText style={{ color: parent === "father" ? white : primary }}>
              {translate("I'm father")}
            </MyText>
          </TouchableOpacity>
        </View>
        <View style={{ width: "90%", marginTop: 10 }}>
          <MyInputWithLabel
            noPlaceHolder={true}
            name="name"
            setInput={setInput}
            text={translate("name")}
            style={{ marginVertical: 10, width: "100%" }}
          />
          <MyInputWithLabel
            noPlaceHolder={true}
            name="lastName"
            setInput={setInput}
            text={translate("last name")}
            style={{ marginVertical: 10, width: "100%" }}
          />
          {main.rtl && (
            <MyInputWithLabel
              keyboardType="number-pad"
              noPlaceHolder={true}
              name="nationalCode"
              setInput={setInput}
              text={translate("national code")}
              style={{ marginVertical: 10, width: "100%" }}
            />
          )}
          {main.rtl && (
            <MyInputWithLabel
              keyboardType="number-pad"
              name="phone"
              noPlaceHolder={true}
              setInput={setInput}
              text="شماره تلفن"
              style={{ marginVertical: 10, width: "100%" }}
            />
          )}
          {!main.rtl && (
            <MyInputWithLabel
              name="email"
              noPlaceHolder={true}
              setInput={setInput}
              text={"email"}
              style={{ marginVertical: 10, width: "100%" }}
            />
          )}
          <MyInputWithLabel
            noPlaceHolder={true}
            name="referId"
            setInput={setInput}
            text={translate("doctor refer id")}
            style={{ marginVertical: 10, width: "100%" }}
          />
          <MyText style={{ color: "#999" }}>
            {translate("current address (optional)")}
          </MyText>
          <View style={{ width: "100%", flexDirection: "row" }}>
            <View style={{ flex: 1 }}>
              <MyInputWithLabel
                noPlaceHolder={true}
                name="referId"
                setInput={setInput}
                text={translate("province")}
                style={{ marginVertical: 10, width: "100%" }}
              />
            </View>
            <View style={{ width: 30 }}></View>
            <View style={{ flex: 1 }}>
              <MyInputWithLabel
                noPlaceHolder={true}
                name="referId"
                setInput={setInput}
                text={translate("city")}
                style={{ marginVertical: 10, width: "100%" }}
              />
            </View>
          </View>
          <View>
            <MyText style={{ color: danger }}>{error}</MyText>
          </View>
          <MyButton
            activeOpacity={nextAvailable ? 0 : 1}
            loading={loading}
            onPress={nextAvailable ? register : null}
            textStyle={{ fontSize: 20 }}
            style={{
              minHeight: 40,
              marginTop: 10,
              backgroundColor: nextAvailable ? primary : "#ddd",
            }}
            text={translate("submit")}
          />
        </View>
        <View style={{ height: 100 }}></View>
      </KeyboardAwareScrollView>
    </View>
  );
}
